/** Legacy built-in admin friend (removed) — strip from lists if still in Firestore. */
export const LEGACY_MORPHEUS_ID = 'admin-morpheus';

export function stripLegacySystemFriends(friends = []) {
  return (friends || []).filter((f) => f.id !== LEGACY_MORPHEUS_ID);
}
